import { useMutation } from "@apollo/client";
import {
  AcknowledgeCapitalGroupMigrationOverrideMutation,
  AcknowledgeCapitalGroupMigrationOverrideMutationVariables,
} from "@ctypes";
import { USER } from "@graphql";
import { ACKNOWLEDGE_CAPITAL_GROUP_MIGRATION_OVERRIDE } from "@graphql/mutations";

/** Clears the one-time migration notice so it does not reappear once acknowledged. */
export const useAcknowledgeCapitalGroupMigrationOverride = () => {
  return useMutation<
    AcknowledgeCapitalGroupMigrationOverrideMutation,
    AcknowledgeCapitalGroupMigrationOverrideMutationVariables
  >(ACKNOWLEDGE_CAPITAL_GROUP_MIGRATION_OVERRIDE, {
    refetchQueries: [{ query: USER }],
    awaitRefetchQueries: true,
  });
};
